import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    recentProjects: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Header for the Recent Projects section in the Project Switcher */
            recentProjects: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSwitcherSheet.recentProjects?c=2g8ni0fue5u4q", defaultMessage: "Recent Projects" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
